import { safeLiquidRender } from '@rightmessage/shared-utils'
import type { Dimension, Segment, LogicDefinition } from '../types/config'

export interface SegmentUtilContext {
  phrases?: Record<string, any>
  questions?: any[]
  segmentGroups?: any[]
  integratedPartner?: any
}

export const renderText = (
  t: string,
  context: SegmentUtilContext = {},
  truncationLimit = 100
) => {
  if (!t) return false

  let tmp = document.createElement('DIV')
  tmp.innerHTML = t

  // Replace Liquid fragments with fallback text
  let text = tmp.innerHTML.replace(
    /{{ phrases\.(\w+) }}/g,
    (match, phraseId) => {
      const phrase = context.phrases?.[phraseId]
      return phrase ? phrase.fallbackText : match
    }
  )

  text = safeLiquidRender(text, {})

  // Convert HTML to plain text
  tmp.innerHTML = text
  text = tmp.textContent || tmp.innerText || ''

  return text.length > truncationLimit
    ? text.substring(0, truncationLimit) + '...'
    : text
}

export const renderTextForQuestion = (
  question: any,
  context: SegmentUtilContext = {},
  truncateLimit = 100
) => {
  if (!question || !question.text) return false
  return renderText(question.text, context, truncateLimit)
}

export const segmentName = (
  segment: Segment,
  context: SegmentUtilContext = {}
): string | null => {
  if (segment && segment.name === 'INT_OTHER') {
    // Find segment group that contains this segment
    const segmentGroup = context.segmentGroups?.find((sg) =>
      sg.segments?.some((s: any) => s.id === segment.id)
    )
    if (!segmentGroup) return 'Other'

    // Find question for this segment group
    const question = context.questions?.find(
      (q) => q.segmentGroupId === segmentGroup.id
    )
    return question?.otherOptions?.otherLabel || null
  }
  return segment ? segment.name : null
}

export const indexOfSyncUpDefinition = (
  definition: LogicDefinition,
  segmentGroup: Dimension,
  context: SegmentUtilContext = {}
) => {
  const { integratedPartner } = context
  const customFieldId = segmentGroup.syncToCustomField

  if (!definition || !integratedPartner) return -1

  for (let i = 0; i < (definition.or || []).length; i++) {
    const orSignal = definition.or[i]

    if (orSignal.and && orSignal.and.length === 1) {
      const andSignal = orSignal.and[0]

      if (
        andSignal.$source === integratedPartner.name &&
        andSignal.$type === 'customField' &&
        andSignal.operator === 'equals' &&
        (andSignal.customFieldId === customFieldId ||
          (!andSignal.customFieldId && !customFieldId))
      ) {
        return i
      }
    }
  }

  return -1
}
